import { BotProtectionContainer } from './BotProtectionContainer'
import type { BotProtectionWidgetProps } from './types'
import { useBotProtectionWidget } from './useBotProtectionWidget'

export const BotProtectionWidget = (props: BotProtectionWidgetProps) => {
  const { containerRef } = useBotProtectionWidget(props)

  return (
    <BotProtectionContainer
      containerName={props.containerName}
      containerRef={containerRef}
    />
  )
}
